import { Link } from "react-router-dom";
import axios from 'axios';
import config from '../../config/config';
import { CLEANUP_MESSAGE, ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../common/Constant';
import { toastSuccess } from '../../common/Toast';


const CancelConfirmation = ({ CleanupConformationApiUrl, handleCancelPopup }) => {

  function handleCancelPopupApi() {
    const token = localStorage.getItem("Token");
    handleCancelPopup();
   
  };

  return (
    <>
      <div className="modal fade" id="CancelModal" tabIndex={-1} aria-labelledby="delete" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="title-model">Confirmation</p>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p className="col-form-label">Are you sure you want to clear this sale? All items will cleared.</p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link to="#" className="btn btn-primary btn-md me-1" data-bs-dismiss="modal" onClick={() => handleCancelPopupApi()}>OK </Link>
              <Link to="#" className="btn btn-dark btn-md me-1" data-bs-dismiss="modal">Cancel </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CancelConfirmation;